import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import axios from "axios";
import utils from "@utils";
import { Link } from "react-router";
import {
	InvoiceService,
	ClientService,
	ProjectService,
	OfficerService,
	OrganizationService,
} from "@services";
import { INVOICE_STATUS_MAP, PAYMENTS_TAB_MENU, PAYMENTS_V4_TAB_MENU } from "@constants";
import MaskedInput from "react-text-mask";
import { SearchField, Select } from "@components/common";
import {
	HeaderGrid,
	TabMenu,
	Switch,
	SearchOfficerModal,
	DisputeInvoiceModal,
	SendToContactModal,
	EditInvoiceModal,
	Image,
	ScrollDetect,
} from "../../../components";

import "./PaymentList.scss";
import { FEATURES } from "../../../js/constants";

let cancel;
let getAgenciesCancel;
export class PaymentList extends Component {
	constructor(props) {
		super(props);
		const {
			router: {
				params: { viewType },
				location: { query },
			},
		} = props;
		this.state = {
			showFilters: false,
			activeType: viewType || "submission",
			hasMore: true,
			totalFees: 0,
			invoiceList: [],
			clients: [],
			clientsLoading: false,
			projects: [],
			projectsLoading: false,
			locations: [],
			locationsLoading: false,
			agencies: {
				data: [],
				loading: false,
			},
			officerName: "",
			pageNumber: 1,
			filters: {
				organizationId: parseInt(query?.organizationId, 10) || "",
				clientId: parseInt(query?.clientId, 10) || "",
				projectId: parseInt(query?.projectId, 10) || "",
				locationId: parseInt(query?.locationId, 10) || "",
				officerId: parseInt(query?.officerId, 10) || "",
				jobStartDate: query?.jobStartDate || "",
				jobEndDate: query?.jobEndDate || "",
				invoiceStartDate: query?.invoiceStartDate || "",
				invoiceEndDate: query?.invoiceEndDate || "",
				prePay: query.prePay === "true" || null,
				sameDayPaid: query.sameDayPaid === "true" || null,
				vehicleInvoicingRequired: query.vehicleInvoicingRequired === "true" || null,
			},
			counts: {
				CreatedTotalAmount: 0,
				PendingReviewTotalAmount: 0,
				PendingPaymentTotalAmount: 0,
				DisputedCount: 0,
			},
			loadingCounts: true,
			selectAll: false,
			selectedInvoices: [],
			expandDropdownId: null,
			showSearchOfficerModal: false,
			showSendInvoiceModal: false,
			editInvoiceId: 0,
			disputeInvoiceId: 0,
			sendModalInvoiceId: 0,
			sendModalClientId: 0,
			sendModalAgencyId: 0,
			searchingInvoices: false,
			downloadingInvoice: undefined,
		};

		this.dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
		this._disputeInvoiceModal = React.createRef();
		this._editInvoiceModal = React.createRef();
	}

	componentDidMount() {
		const { user, router } = this.props;

		// Reroute from this page if user is a regular staff member
		if (
			!user.IsStaffAdmin &&
			!user.IsInternalCoordinator &&
			(user.isAgencyAdmin() || user.isLEA())
		) {
			window.location.href = "/";
		}

		if (user.isSuperAdmin()) {
			this.getAgencies();
		}

		this.getClients();
		document.addEventListener("click", this.clickEventListener);

		// Caching set up to keep a users filters and list items when navigating away from the page
		const {
			filters: { officerId },
		} = this.state;
		if (global.rkc?.pl) {
			this.setState(global.rkc.pl, () => {
				const { filters, activeType, pageNumber } = this.state;
				router.push(this.updateUrl());
				this.getInvoiceCounts();
				const invoiceStatus = INVOICE_STATUS_MAP.find(
					({ type: invoiceType }) => invoiceType === activeType,
				);
				const jobStartDate =
					utils.isDesktopSafari || utils.isIE
						? filters.jobStartDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
						: filters.jobStartDate;
				const jobEndDate =
					utils.isDesktopSafari || utils.isIE
						? filters.jobEndDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
						: filters.jobEndDate;
				const invoiceStartDate =
					utils.isDesktopSafari || utils.isIE
						? filters.invoiceStartDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
						: filters.invoiceStartDate;
				const invoiceEndDate =
					utils.isDesktopSafari || utils.isIE
						? filters.invoiceEndDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
						: filters.invoiceEndDate;

				// Cleaning up query params so that unnecessary fields are not sent as part of the network request
				const queryParams = {
					pageNumber: 1,
					displayCount: (pageNumber - 1 || 1) * 25,
					status: invoiceStatus.status,
					sortBy: "StartDateTime",
					asc: activeType !== "paid",
					organizationId: filters.organizationId || undefined,
					clientId: filters.clientId || undefined,
					projectId: filters.projectId || undefined,
					locationId: filters.locationId || undefined,
					officerId: filters.officerId || undefined,
					prePay: filters.prePay || undefined,
					sameDayPaid: filters.sameDayPaid || undefined,
					vehicleInvoicingRequired: filters.vehicleInvoicingRequired || undefined,
					jobStartDate,
					jobEndDate,
					invoiceStartDate,
					invoiceEndDate,
				};

				InvoiceService.getInvoiceList({
					getCancelToken: c => {
						cancel = c;
					},
					...queryParams,
				})
					.then(({ data: { ItemList } }) => this.setState({ invoiceList: ItemList }))
					.catch(() => {})
					.finally(() => {
						global.rkc.pl = undefined;
					});
			});
		} else if (officerId) {
			// When refreshing the page and an officerId is present, update the officer name in state
			OfficerService.getById(officerId)
				.then(
					({
						data: {
							ContactViewModel: { FirstName, LastName },
						},
					}) => {
						this.setState({ officerName: `${FirstName} ${LastName}` });
					},
				)
				.catch(() => {});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { invoiceList } = this.state;

		if (prevState.selectedInvoices) {
			const updatedSelectedInvoices = prevState.selectedInvoices.filter(prevInvoice => {
				const matchingInvoice = invoiceList.find(invoice => invoice.Id === prevInvoice.Id);
				return matchingInvoice && matchingInvoice.Status === prevInvoice.Status;
			});

			if (updatedSelectedInvoices.length !== prevState.selectedInvoices.length){
				this.setState({ selectedInvoices: updatedSelectedInvoices });
			}
		}
	}


	componentWillUnmount() {
		document.removeEventListener("click", this.clickEventListener);
		if (!global.rkc) global.rkc = {};
		global.rkc.pl = this.state;
	}

	/** Listens for any clicks outside of the actions dropdown menu in order to handle closing the dropdown
	 * @param {Event} event The HTML event that informs us what was clicked on
	 */
	clickEventListener = ({ target }) => {
		const { expandDropdownId } = this.state;
		const actions = document.getElementById(`action-menu_${expandDropdownId}`);
		if (
			!target.closest(".btn-group") &&
			actions?.classList.contains("open") &&
			expandDropdownId !== null
		) {
			this.setState({ expandDropdownId: null });
		}
	};

	/* ***** START Service Methods ***** */

	/** Retrieves a paginated list of all invoice that match the user's selected filter criteria */
	getInvoices = () => {
		const { lang } = global;
		const {
			pageNumber,
			activeType,
			filters: {
				organizationId,
				clientId,
				projectId,
				locationId,
				officerId,
				jobStartDate,
				jobEndDate,
				prePay,
				sameDayPaid,
				invoiceStartDate,
				invoiceEndDate,
				vehicleInvoicingRequired,
			},
		} = this.state;
		const invoiceStatus = INVOICE_STATUS_MAP.find(
			({ type: invoiceType }) => invoiceType === activeType,
		);
		// if paid filter the invoice list to display invoices from the last 6 months
		const sixMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 6));
		const startDate = utils.formatDate(sixMonthsAgo, "en-US", undefined, "numeric");
		const endDate = utils.formatDate(undefined, "en-US", undefined, "numeric");

		const params = {
			organizationId,
			clientId,
			projectId,
			locationId,
			officerId,
			jobStartDate,
			jobEndDate,
			prePay,
			sameDayPaid,
			pageNumber,
			status: invoiceStatus.status,
			displayCount: activeType === "paid" ? 100 : 25,
			sortBy: "StartDateTime",
			asc: activeType !== "paid",
			invoiceStartDate: activeType === "paid" ? startDate : invoiceStartDate,
			invoiceEndDate: activeType === "paid" ? endDate : invoiceEndDate,
			vehicleInvoicingRequired,
		};

		// If there is a request already running, abort it and start a new one
		if (cancel) cancel();

		// Only take non null filters
		const filterParams = Object.fromEntries(
			Object.entries(params).filter(([, value]) => value !== null && value !== ""),
		);

		InvoiceService.getInvoiceList({
			getCancelToken: c => {
				cancel = c;
			},
			...filterParams,
		})
			.then(({ data }) => {
				cancel = undefined;
				this.setState(prevState => ({
					invoiceList:
						pageNumber === 1
							? data.ItemList
							: [...prevState.invoiceList, ...data.ItemList],
					hasMore:
						activeType === "paid"
							? data.ItemList.length >= 100
							: data.ItemList.length >= 25,
					pageNumber: prevState.pageNumber + 1,
					totalFees: data.TotalAmount,
				}));
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					this.setState({ pageNumber: 1, hasMore: false });
					utils.notify({
						type: "error",
						message: lang.t("Error loading invoices"),
						timeOut: 1500,
					});
				}
			});
	};

	/** Retrieves the total number of invoices and their summed amounts based on selected filters */
	getInvoiceCounts = () => {
		const { lang } = global;
		const {
			pageNumber,
			filters: {
				organizationId,
				clientId,
				projectId,
				locationId,
				officerId,
				jobStartDate,
				jobEndDate,
				invoiceStartDate,
				invoiceEndDate,
				prePay,
				sameDayPaid,
				vehicleInvoicingRequired,
			},
		} = this.state;
		const params = {
			organizationId,
			clientId,
			projectId,
			locationId,
			officerId,
			jobStartDate,
			jobEndDate,
			invoiceStartDate,
			invoiceEndDate,
			prePay,
			sameDayPaid,
			pageNumber,
			displayCount: 25,
			sortBy: "StartDateTime",
			asc: true,
			vehicleInvoicingRequired,
		};

		// Only take non null filters
		const filterParams = Object.fromEntries(
			Object.entries(params).filter(([, value]) => value !== null && value !== ""),
		);

		InvoiceService.getCounts(filterParams)
			.then(({ data }) => {
				const counts = {
					...data,
					CreatedTotalAmount: utils.currencyFormatter(data.CreatedTotalAmount),
					PendingReviewTotalAmount: utils.currencyFormatter(
						data.PendingReviewTotalAmount,
					),
					PendingPaymentTotalAmount: utils.currencyFormatter(
						data.PendingPaymentTotalAmount,
					),
				};
				this.setState({ counts, loadingCounts: false });
			})
			.catch(() => {
				this.setState({ loadingCounts: false });
				utils.notify({
					type: "error",
					message: lang.t("Error loading invoices"),
					timeOut: 1500,
				});
			});
	};

	/** Retrieves all agencies that the user can filter the job list by */
	getAgencies = () => {
		const { lang } = global;
		const { user } = this.props;

		// This select list is only available to Super Admins
		if (!user.isSuperAdmin()) return;

		this.setState(state => ({ agencies: { ...state.agencies, loading: true } }));

		// If there is a request already running, abort it and start a new one
		if (getAgenciesCancel) {
			getAgenciesCancel();
		}
		OrganizationService.getAll({ minimalData: true }, c => {
			getAgenciesCancel = c;
		})
			.then(({ data }) => {
				getAgenciesCancel = undefined;
				const agencies = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ agencies: { ...agencies, data: agencies } });
			})
			.catch(error => {
				this.setState(state => ({ agencies: { ...state.agencies, loading: false } }));
				if (!axios.isCancel(error)) {
					utils.notify({
						type: "error",
						message: lang.t("Error loading Agencies"),
						timeOut: 1500,
					});
				}
			})
			.finally(() =>
				this.setState(state => ({ agencies: { ...state.agencies, loading: false } })),
			);
	};

	/** Retrieves all clients that the user can filter the invoice list by */
	getClients = () => {
		const {
			user: {
				Organization: { Id },
			},
		} = this.props;
		const {
			filters: { includeInactive, organizationId, clientId },
		} = this.state;
		this.setState({ clientsLoading: true });

		ClientService.getAll({ includeInactive, organizationId: organizationId || Id })
			.then(({ data }) => {
				const clients = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ clients, clientsLoading: false }, () => {
					if (clientId) {
						this.getProjects();
					}
				});
			})
			.catch(() => {
				this.setState({ clients: [], clientsLoading: false });
			});
	};

	/** Retrieves all projects that the user can filter the invoice list by */
	getProjects = () => {
		const {
			filters: { clientId, includeInactive, projectId },
		} = this.state;
		this.setState({ projectsLoading: true, locations: [], projects: [] });

		ProjectService.getAll({ includeAll: includeInactive, clientId })
			.then(({ data: { ItemList } }) => {
				const projects = ItemList.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ projects, projectsLoading: false }, () => {
					if (projectId) {
						this.getLocations();
					}
				});
			})
			.catch(() => {
				this.setState({ projects: [], projectsLoading: false });
			});
	};

	/** Retrieves all locations that the user can filter the invoice list by.
	 * For non-coordinator users, the list of locations retrieved is based on the selected project.
	 * For coordinators, the list of locations is retrieved based on the selected client.
	 */
	getLocations = () => {
		const {
			filters: { clientId },
		} = this.state;
		this.setState({ locationsLoading: true });

		ClientService.getLocations(clientId)
			.then(({ data }) => {
				const locations = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ locations, locationsLoading: false });
			})
			.catch(() => {
				this.setState({ locations: [], locationsLoading: false });
			});
	};

	/** Sends an invoice to the client */
	sendInvoiceToClient = ({ invoiceId, contactId, additionalContactEmails }) => {
		const { lang } = global;

		InvoiceService.sendInvoiceToClient(
			{ contactId },
			{ invoiceIds: [invoiceId], additionalContactEmails },
		)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice Sent"),
				});
				this.setState(
					prevState => ({
						invoiceList: prevState.invoiceList.filter(item => item.Id !== invoiceId),
					}),
					() => this.getInvoiceCounts(),
				);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error sending invoice"),
					timeOut: 1500,
				});
			});
	};

	/* ***** END Service Methods ***** */

	/** Updates the page URL, removing unused or redundant query string value where possible
	 * @return {String} An updated url including any filtering done by the user
	 */
	updateUrl = () => {
		const { activeType, filters } = this.state;
		const jobStartDate =
			utils.isDesktopSafari || utils.isIE
				? filters.jobStartDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
				: filters.jobStartDate;
		const jobEndDate =
			utils.isDesktopSafari || utils.isIE
				? filters.jobEndDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
				: filters.jobEndDate;
		const invoiceStartDate =
			utils.isDesktopSafari || utils.isIE
				? filters.invoiceStartDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
				: filters.invoiceStartDate;
		const invoiceEndDate =
			utils.isDesktopSafari || utils.isIE
				? filters.invoiceEndDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
				: filters.invoiceEndDate;

		const filterQuery = {};
		if (filters.organizationId) filterQuery.organizationId = filters.organizationId;
		if (filters.clientId) filterQuery.clientId = filters.clientId;
		if (filters.projectId) filterQuery.projectId = filters.projectId;
		if (filters.locationId) filterQuery.locationId = filters.locationId;
		if (filters.officerId) filterQuery.officerId = filters.officerId;
		if (jobStartDate) filterQuery.jobStartDate = jobStartDate;
		if (jobEndDate) filterQuery.jobEndDate = jobEndDate;
		if (invoiceStartDate) filterQuery.invoiceStartDate = invoiceStartDate;
		if (invoiceEndDate) filterQuery.invoiceEndDate = invoiceEndDate;
		if (filters.prePay) filterQuery.prePay = true;
		if (filters.vehicleInvoicingRequired) filterQuery.vehicleInvoicingRequired = true;
		if (filters.sameDayPaid) filterQuery.sameDayPaid = true;
		const queryString = new URLSearchParams(filterQuery).toString();
		return `/payments/list/${activeType}${queryString !== "" ? `?${queryString}` : ""}`;
	};

	/** Updates the payment list status according to what the user clicks or selects from the <HeaderGrid> component
	 * @param {'submission|review|payment|dispute|paid'} type A string value indicating which invoice status the user would like to filter list results by
	 */
	setActiveGrid = type => {
		this.setState(
			prevState => {
				const { filters } = prevState;
				return {
					pageNumber: 1,
					invoiceList: [],
					selectedInvoices: [],
					selectAll: false,
					hasMore: true,
					activeType: type,
					filters,
				};
			},
			() => {
				const { router } = this.props;
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	/** Calls an independent request to search for the invoice number
	 * if the invoice is found the user is navigated to the details page for that invoice
	 */
	goToInvoice = invoiceNumber => {
		const { lang } = global;
		const { router } = this.props;
		const invoiceId = parseInt(invoiceNumber, 10);
		if (Number.isNaN(invoiceId)) {
			utils.notify({
				type: "error",
				message: lang.t("Invalid Invoice Id"),
			});
			return;
		}
		this.setState({ searchingInvoices: true });

		InvoiceService.getInvoiceById(invoiceNumber)
			.then(() => {
				this.setState({ searchingInvoices: false });
				router.push(`/payments/${invoiceNumber}`);
			})
			.catch(() => {
				this.setState({ searchingInvoices: false });
				utils.notify({
					type: "error",
					message: lang.t("Invoice could not be found"),
				});
			});
	};

	/** Navigates the user the RKPAY Invoice List or the Manual Invoice List when clicking on the sub navbar  */
	onClickTab = ({ tabNumber, url }) => {
		const {
			router: { push },
		} = this.props;
		const thisTab = PAYMENTS_TAB_MENU.find(tab => tab.type === "list");
		if (tabNumber !== thisTab.tabNumber) push(url);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleAgencyChange = event => {
		const {
			filters: { organizationId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === organizationId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
				filters: {
					...prevState.filters,
					organizationId: event?.value || "",
					clientId: "",
					projectId: "",
					locationId: "",
				},
				projects: [],
				locations: [],
			}),
			() => {
				this.getClients();
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	/* ***** START Change handler methods ***** */
	handleClientChange = event => {
		const {
			filters: { clientId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === clientId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
				filters: {
					...prevState.filters,
					clientId: event?.value || "",
					projectId: "",
					locationId: "",
				},
				projects: [],
				locations: [],
			}),
			() => {
				if (event) {
					this.getProjects();
					this.getLocations();
				}
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	handleProjectChange = event => {
		const {
			filters: { projectId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === projectId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
				filters: {
					...prevState.filters,
					projectId: event?.value || "",
					locationId: "",
				},
				locations: [],
			}),
			() => {
				this.getLocations();
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	handleLocationChange = event => {
		const {
			filters: { locationId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === locationId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
				filters: {
					...prevState.filters,
					locationId: event?.value || "",
				},
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	handleOfficerChange = officer => {
		const {
			filters: { officerId },
		} = this.state;
		const { router } = this.props;
		if (officer?.Id === officerId) return;
		this.setState(
			prevState => ({
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
				filters: {
					...prevState.filters,
					officerId: officer?.Id || "",
				},
				officerName: `${officer?.FirstName} ${officer?.LastName}`,
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	handleClearInput = () => {
		const { router } = this.props;
		this.setState(
			prevState => ({
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
				filters: {
					...prevState.filters,
					officerId: "",
				},
				officerName: "",
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	handleDateInputChange = (property, { target: { value } }) => {
		const { router } = this.props;
		// For date inputs on iOS, all '/' characters need to be replaced with '-'
		const formattedValue = utils.isIOSDevice ? value.replace(/\//gi, "-") : value;
		this.setState(
			prevState => ({
				filters: { ...prevState.filters, [property]: formattedValue },
				pageNumber: 1,
				invoiceList: [],
				selectedInvoices: [],
				selectAll: false,
				hasMore: true,
			}),
			() => {
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};

	handleSwitchChange = name => {
		const { router } = this.props;
		this.setState(
			prevState => {
				const { filters } = prevState;
				if (name === "vehicleInvoicingRequired" && filters[name] === true) {
					filters[name] = null;
				} else {
					filters[name] = !filters[name];
				}
				return {
					pageNumber: 1,
					invoiceList: [],
					selectedInvoices: [],
					selectAll: false,
					hasMore: true,
					filters,
				};
			},
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getInvoices();
				this.getInvoiceCounts();
				router.push(this.updateUrl());
			},
		);
	};
	/* ***** END Change handler methods ***** */

	/** Approve the selected group of invoices from the payment list on Click
	 * @param {Number} invoiceStatus The status of the selected invoice
	 */
	approveSelectedInvoice = invoiceStatus => {
		const { lang } = global;
		const { selectedInvoices } = this.state;
		const idArray = selectedInvoices.map(({ Id }) => Id);
		InvoiceService.changeInvoiceUserStatus({ idArray, status: invoiceStatus })
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice(s) Approved"),
				});
				this.setState(
					prevState => ({
						selectedInvoices: [],
						invoiceList: prevState.invoiceList.filter(
							item => idArray.indexOf(item.Id) === -1,
						),
					}),
					() => this.getInvoiceCounts(),
				);
			})
			.catch(() => {
				this.setState({ selectedInvoices: [] });
				utils.notify({
					type: "error",
					message: lang.t("Error updating invoice"),
				});
			});
	};

	/** Send the selected group of invoices from the payment list on Click */
	sendSelectedInvoices = () => {
		const { lang } = global;
		const { router } = this.props;
		const { selectedInvoices } = this.state;
		// store the first instance of clientId from the selected invoices
		const firstClientId = selectedInvoices[0].ClientId;
		// compare the first clientId to all other clientIds in the selected invoices
		const otherClientId = selectedInvoices.filter(item => item.ClientId !== firstClientId);
		// All clientIds must match in order to send the selected invoices
		if (otherClientId.length > 0) {
			utils.notify({
				type: "error",
				message: lang.t("Please select invoices with the same client to continue"),
			});
			return;
		}
		const InvoiceIds = selectedInvoices.map(({ Id }) => Id);
		const agencyId = selectedInvoices.find(invoice => invoice.AgencyId).AgencyId;
		router.push({
			pathname: "/payments/invoicepreview",
			state: { InvoiceIds, clientId: firstClientId, agencyId },
		});
	};

	/** Send invoice to the client for individual invoices
	 * @param {Object} invoice The invoice object being selected to be sent
	 */
	handleSendInvoice = invoice => {
		const {
			user: {
				Organization: { Id: orgId },
			},
		} = this.props;
		// If the invoice belongs to the current user's agency, open the send invoice modal
		if (invoice.AgencyId === orgId) {
			this.toggleSendInvoiceModal(invoice);
		} else {
			// Otherwise, the invoice should be sent to the managing agency automatically instead
			this.sendInvoiceToClient({ invoiceId: invoice.Id, contactId: undefined });
		}
	};

	/** Send the invoice to the client via the send invoice modal
	 * @param {Number} invoiceId The id of the invoice being sent
	 * @param {Number} contactId  The id of the client receiving the invoice
	 * @param {String} additionalContactEmails The email of the client receiving the invoice
	 */
	sendInvoiceFromModal = (invoiceId, contactId, additionalContactEmails) => {
		this.sendInvoiceToClient({ invoiceId, contactId, additionalContactEmails });
		this.toggleSendInvoiceModal();
	};

	/** Selects all invoices from from the payment list on change */
	selectAllInvoices = () => {
		const { invoiceList, selectAll } = this.state;
		if (selectAll) {
			this.setState({
				selectedInvoices: [],
				selectAll: false,
			});
		} else {
			this.setState({
				selectedInvoices: invoiceList,
				selectAll: true,
			});
		}
	};

	/** Manually select invoices from from the payment list on change
	 * @param {Number} invoiceId The id of the invoice(s) being selected
	 */
	updateSelectedInvoices = invoiceId => {
		const {
			selectedInvoices: [...selectedInvoices],
			invoiceList,
		} = this.state;

		if (selectedInvoices.some(invoice => invoice.Id === invoiceId)) {
			this.setState(prevState => ({
				selectedInvoices: prevState.selectedInvoices.filter(
					invoice => invoice.Id !== invoiceId,
				),
				selectAll: false,
			}));
		} else {
			selectedInvoices.push(invoiceList.find(invoice => invoice.Id === invoiceId));
			this.setState({
				selectedInvoices,
				selectAll: selectedInvoices.length === invoiceList.length,
			});
		}
	};

	/** Pay the selected group of invoices from the payment list on Click
	 * @param {Boolean} payAll determines wether or not to pay all invoices or only the selected invoices
	 */
	paySelectedInvoices = payAll => {
		const { router } = this.props;
		const { selectedInvoices, filters } = this.state;
		const InvoiceIds = payAll ? [] : selectedInvoices.map(({ Id }) => Id);
		router.push({
			pathname: "/payments/invoice",
			query: { payAll: payAll || undefined },
			state: { InvoiceIds, filters },
		});
	};

	/** Approve individual invoices, remove that invoice form the list and updates the counts
	 * @param {Number} invoiceId The id of the invoice being approved
	 * @param {Number} invoiceStatus The status of the invoice being approved
	 */
	approveIndividualInvoice = (invoiceId, invoiceStatus) => {
		const { lang } = global;
		InvoiceService.changeInvoiceUserStatus({ idArray: [invoiceId], status: invoiceStatus })
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice(s) Approved"),
				});
				this.setState(
					prevState => ({
						invoiceList: prevState.invoiceList.filter(item => item.Id !== invoiceId),
					}),
					() => this.getInvoiceCounts(),
				);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error updating invoice"),
				});
			});
	};

	/** Dispute individual invoices, remove that invoice form the list and updates the counts */
	disputeInvoice = () => {
		const { disputeInvoiceId } = this.state;
		this.setState(
			prevState => ({
				invoiceList: prevState.invoiceList.filter(item => item.Id !== disputeInvoiceId),
			}),
			() => this.getInvoiceCounts(),
		);
	};

	/** Navigates the user to the invoice details page in order to pay
	 * @param {Number} invoiceId The id of the invoice being payed
	 */
	payIndividualInvoice = invoiceId => {
		const { router } = this.props;
		router.push({
			pathname: "/payments/invoice",
			state: { InvoiceIds: [invoiceId] },
		});
	};

	/** Toggles the button menu to display a list of actions can be performed by a user on an invoice
	 * @param {Number} id The id of element whose dropdown is toggled
	 */
	toggleActionDropdown = id => {
		let invoiceId = id;
		const actions = document.getElementById(`action-menu_${invoiceId}`);
		if (actions.classList.contains("open")) invoiceId = null;
		this.setState({ expandDropdownId: invoiceId });
	};

	/** Toggles the SendInvoiceModal
	 * @param {Object} invoice The invoice being sent
	 */
	toggleSendInvoiceModal = invoice => {
		this.setState(prevState => {
			if (prevState.showSendInvoiceModal || !invoice)
				return { showSendInvoiceModal: false, sendModalClientId: 0, sendModalAgencyId: 0 };
			return {
				showSendInvoiceModal: true,
				sendModalInvoiceId: invoice.Id,
				sendModalClientId: invoice.ClientId,
				sendModalAgencyId: invoice.AgencyId,
			};
		});
	};

	/** Opens the SearchOfficerModal in order to filter the payment list by the officer that is selected */
	openSearchOfficerModal = () => {
		this.setState({ showSearchOfficerModal: true });
	};

	/** Navigates the user to the invoice details page when specifically clicking on that invoice from the payment list
	 * @param {Number} jobId The job id of the invoice being navigated to
	 */
	navigateToJob = jobId => {
		const { router } = this.props;
		router.push(`/jobs/${jobId}`);
	};

	searchFieldCSSClasses = () => {
		const { user } = this.props;
		const { totalFees } = this.state;

		if (user.isCoordinator() || (user.isLEA() && user.IsInternalCoordinator && totalFees)) {
			return "col-sm-3";
		}
		if (user.isSuperAdmin()) {
			return "col-sm-3 col-sm-offset-6";
		}
		return "col-sm-3 col-sm-offset-9";
	};

	downloadInvoicePDF = invoiceId => {
		const { lang } = global;
		this.setState({ downloadingInvoice: invoiceId });
		InvoiceService.downloadInvoicePDF(invoiceId)
			.then(({ data }) => {
				utils.downloadFromBlobResponse(data, `invoice_${invoiceId}.pdf`);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("The invoice download failed"),
					timeOut: 1500,
				});
			})
			.finally(() => this.setState({ downloadingInvoice: undefined }));
	};

	navToShowReceipt = invoiceId => {
		const { lang } = global;
		const { router } = this.props;

		InvoiceService.getInvoiceById(invoiceId)
			.then(({ data: invoice }) => {
				router.push({ pathname: `/payments/receipt/${invoice?.TransactionId}` });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading invoice details"),
				});
				router.push("/payments/list");
			});
	};

	render() {
		const { lang } = global;
		const {
			showFilters,
			activeType,
			counts,
			loadingCounts,
			totalFees,
			invoiceList,
			hasMore,
			clients,
			clientsLoading,
			projects,
			projectsLoading,
			locations,
			locationsLoading,
			filters,
			officerName,
			selectedInvoices,
			selectAll,
			expandDropdownId,
			editInvoiceId,
			showSearchOfficerModal,
			showSendInvoiceModal,
			sendModalInvoiceId,
			sendModalClientId,
			sendModalAgencyId,
			searchingInvoices,
			agencies,
			downloadingInvoice,
		} = this.state;
		const { user } = this.props;

		const amountTitle = () => {
			let title;
			switch (activeType) {
				case "submission":
				case "dispute":
					title = lang.t("Estimated Amount");
					break;
				case "review":
				case "paid":
					title = lang.t("Invoiced Amount");
					break;
				default:
					title = lang.t("Approved Amount");
					break;
			}
			return title;
		};

		/**
		 *  Updates the size of the Amount column determined by the activeType and user type
		 * @returns {String} The bootstrap column class to be used
		 */
		const amountColumn = () => {
			let col;
			if (
				(activeType === "payment" || activeType === "review" || activeType === "paid") &&
				(user.isAgencyAdmin() || user.isSuperAdmin())
			)
				col = "col-sm-2";
			else if (
				(activeType === "review" || activeType === "paid") &&
				(user.isLEA() || user.isCoordinator())
			)
				col = "col-sm-2";
			else if (
				(activeType !== "dispute" || activeType !== "review" || activeType !== "paid") &&
				user.isCoordinator()
			)
				col = "col-sm-2";
			else {
				col = "col-sm-3";
			}
			return col;
		};

		const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === "invoicingv3");
		const isInvoicingV2 =
			user.Organization.NonRKPayInvoicingEnabled || user.Organization.NonRKPayPaymentsEnabled;
		const isOfficerInvoicingV3 = user.Features.some(
			f => f.toLowerCase() === FEATURES.OFFICER_INVOICING_V3,
		);

		let paymentTabs =
			isInvoicingV3 || isInvoicingV2
				? PAYMENTS_TAB_MENU.map(item => {
						if (item.type === "manual")
							return {
								...item,
								text: lang.t("Agency"),
								dataTestId: "payment_page__agency_tab",
							};
						return {
							...item,
							text: lang.t("Officer"),
							dataTestId: "payment_page__officer_tab",
						};
					})
				: PAYMENTS_TAB_MENU;

		const isPaymentsTabV4Enabled = user.isSuperAdmin() || (isInvoicingV3 && isOfficerInvoicingV3);

		if (isPaymentsTabV4Enabled) {
			paymentTabs = PAYMENTS_V4_TAB_MENU.map(item => {
				if (item.type === "v4")
					return {
						...item,
						text: isOfficerInvoicingV3 ? lang.t("Invoicing") : lang.t("Agency"),
						dataTestId: "payment_page__agency_tab",
					};
				return {
					...item,
					text: isOfficerInvoicingV3 ? lang.t("Legacy") : lang.t("Officer"),
					dataTestId: "payment_page__officer_tab",
				};
			});
		}

		return (
			<Fragment>
				<If condition={user.Organization.NonRKPayInvoicingEnabled === true}>
					<TabMenu
						tabs={paymentTabs}
						activeTab={paymentTabs.find(tab => tab.type === "list").tabNumber}
						onClickTab={this.onClickTab}
					/>
				</If>
				<div className="payment-list container">
					{/* Header Grid */}
					<HeaderGrid
						gridOptions={INVOICE_STATUS_MAP}
						activeGrid={activeType}
						counts={counts}
						loadingCounts={loadingCounts}
						setActive={this.setActiveGrid}
						showCounts={false}
					/>
					{/* Header Grid */}

					{/* Invoice Search */}
					<div className="row form-group">
						<If
							condition={
								user.isCoordinator() ||
								(user.isLEA() && user.IsInternalCoordinator && totalFees)
							}
						>
							<div className="col-sm-9 coordinator-disclaimer">
								<h4 className="text-right">
									<small>{lang.t("Your Fees")}</small>
									<br />
									{utils.currencyFormatter(totalFees)}
								</h4>
								<div className="coordinator-message text-muted">
									<em>
										{`${lang.t("This represents total amount you are expected to receive_")}
												${lang.t("It_s helpful to remind officers whose invoices are Pending to submit their invoices for the client_s review_")}
												${lang.t("This will help expedite payment to everyone_")}`}
									</em>
								</div>
							</div>
						</If>
						<div className="col-sm-3">
							<If condition={user.isSuperAdmin()}>
								<div className="form-group select-agency">
									<Select
										name="select-agency"
										placeholder={lang.t("Select Agency")}
										value={parseInt(filters.organizationId, 10)}
										onChange={this.handleAgencyChange}
										options={agencies.data}
										isLoading={agencies.loading}
										isClearable
									/>
								</div>
							</If>
						</div>
						<div className={this.searchFieldCSSClasses()}>
							<SearchField
								formGroupClass="search-invoice"
								placeholder={lang.t("dynamic.Go to", {
									place: `${lang.t("Invoice")} #`,
								})}
								onQuickSearch={this.goToInvoice}
								iconClass={`glyphicon ${searchingInvoices ? "glyphicon-repeat rkf-spin rkf-fw" : "glyphicon-arrow-right"}`}
								dataTesetId="payment_page__search_invoice"
							/>
						</div>
					</div>

					{/* Filters */}
					<div className="payment-filters">
						<div className="row v-align">
							<div className="col-xs-5 col-sm-12">
								<h3 className="hidden-xs">{lang.t("Filters")}</h3>
								<button
									type="button"
									className="btn btn-link text-left filter-toggle visible-xs-inline"
									onClick={() =>
										this.setState(prevState => ({
											showFilters: !prevState.showFilters,
										}))
									}
								>
									<span className="h4">{lang.t("Filters")}</span>
									<i
										className={`text-primary glyphicon glyphicon-chevron-${showFilters ? "up" : "down"}`}
									/>
								</button>
							</div>
							<div className="col-xs-4 visible-xs-inline text-right">
								<div
									className={
										((user.isAgencyAdmin() || user.isSuperAdmin()) &&
											(activeType === "review" ||
												activeType === "payment")) ||
										(user.isLEA() &&
											(user.IsStaffAdmin || user.IsInternalCoordinator) &&
											user.Organization.IsOfficerInvoiceApprovalRequired &&
											activeType === "review")
											? "checkbox"
											: "hidden"
									}
								>
									<label htmlFor="selectAll">
										<input
											type="checkbox"
											name="selectAll"
											id="selectAll"
											checked={selectAll}
											onChange={() => this.selectAllInvoices()}
											title={lang.t("Select All")}
											aria-label="Select All Invoices"
										/>
										{lang.t("Select All")}
									</label>
								</div>
							</div>
							<If
								condition={
									activeType === "payment" &&
									invoiceList.length > 0 &&
									((user.isSuperAdmin() && user.IsStaffAdmin) ||
										user.isAgencyAdmin())
								}
							>
								<div className="col-xs-3 text-right visible-xs">
									<button
										type="button"
										className="btn btn-primary"
										onClick={() => this.paySelectedInvoices(true)}
									>
										{lang.t("Pay All")}
									</button>
								</div>
							</If>
						</div>
						<div className={`row ${showFilters ? "" : "hidden-xs"}`}>
							<div className="col-sm-3 form-group">
								<label htmlFor="select-client">{lang.t("Client")}</label>
								<Select
									id="select-client"
									name="select-client"
									value={filters.clientId}
									options={clients}
									onChange={this.handleClientChange}
									isLoading={clientsLoading}
									isClearable
								/>
							</div>
							<div className="col-sm-3 form-group">
								<label htmlFor="select-project">{lang.t("Project")}</label>
								<Select
									id="select-project"
									name="select-project"
									value={filters.projectId}
									options={projects}
									onChange={this.handleProjectChange}
									isLoading={projectsLoading}
									isClearable
								/>
							</div>
							{activeType !== "paid" && (
								<div className="col-sm-3 form-group">
									<label htmlFor="select-location">{lang.t("Location")}</label>
									<Select
										id="select-location"
										name="select-location"
										value={filters.locationId}
										options={locations}
										onChange={this.handleLocationChange}
										isLoading={locationsLoading}
										isClearable
									/>
								</div>
							)}
							<div className="col-sm-3 form-group">
								<label htmlFor="search-officer">{lang.t("Officers")}</label>
								<div className="input-group search-officer">
									<input
										className="form-control"
										placeholder={lang.t("Search for Officer")}
										value={officerName}
										onClick={this.openSearchOfficerModal}
										onChange={() => {}}
									/>
									<span className="input-group-btn">
										<button
											type="button"
											aria-label="Search Officers"
											className="btn btn-primary"
											onClick={() => {
												if (officerName === "")
													this.openSearchOfficerModal();
												else this.handleClearInput();
											}}
										>
											<Choose>
												<When condition={officerName === ""}>
													<i className="glyphicon glyphicon-search" />
												</When>
												<Otherwise>
													<i className="glyphicon glyphicon-remove" />
												</Otherwise>
											</Choose>
										</button>
									</span>
								</div>
							</div>
						</div>
						<div className={`row ${showFilters ? "" : "hidden-xs"}`}>
							<div className="col-sm-3 form-group">
								<label htmlFor="jobStartDate">{lang.t("Job Start Date")}</label>
								<Choose>
									<When condition={utils.isDesktopSafari || utils.isIE}>
										<MaskedInput
											name="jobStartDate"
											id="jobStartDate"
											type="text"
											mask={this.dateMask}
											className="form-control"
											placeholder="mm/dd/yyyy"
											value={filters.jobStartDate}
											onChange={event =>
												this.handleDateInputChange("jobStartDate", event)
											}
										/>
									</When>
									<Otherwise>
										<input
											name="jobStartDate"
											id="jobStartDate"
											type="date"
											className="form-control"
											value={filters.jobStartDate}
											onChange={event =>
												this.handleDateInputChange("jobStartDate", event)
											}
										/>
									</Otherwise>
								</Choose>
							</div>
							<div className="col-sm-3 form-group">
								<label htmlFor="jobEndDate">{lang.t("Job End Date")}</label>
								<Choose>
									<When condition={utils.isDesktopSafari || utils.isIE}>
										<MaskedInput
											name="jobEndDate"
											id="jobEndDate"
											type="text"
											mask={this.dateMask}
											className="form-control"
											placeholder="mm/dd/yyyy"
											value={filters.jobEndDate}
											onChange={event =>
												this.handleDateInputChange("jobEndDate", event)
											}
										/>
									</When>
									<Otherwise>
										<input
											name="jobEndDate"
											id="jobEndDate"
											type="date"
											className="form-control"
											min={filters.jobStartDate}
											value={filters.jobEndDate}
											onChange={event =>
												this.handleDateInputChange("jobEndDate", event)
											}
										/>
									</Otherwise>
								</Choose>
							</div>
							{activeType !== "paid" && (
								<>
									<div className="col-sm-3 form-group">
										<label htmlFor="invoiceStartDate">
											{lang.t("Invoice Start Date")}
										</label>
										<Choose>
											<When condition={utils.isDesktopSafari || utils.isIE}>
												<MaskedInput
													name="invoiceStartDate"
													id="invoiceStartDate"
													type="text"
													mask={this.dateMask}
													className="form-control"
													placeholder="mm/dd/yyyy"
													value={filters.invoiceStartDate}
													onChange={event =>
														this.handleDateInputChange(
															"invoiceStartDate",
															event,
														)
													}
												/>
											</When>
											<Otherwise>
												<input
													name="invoiceStartDate"
													id="invoiceStartDate"
													type="date"
													className="form-control"
													value={filters.invoiceStartDate}
													onChange={event =>
														this.handleDateInputChange(
															"invoiceStartDate",
															event,
														)
													}
												/>
											</Otherwise>
										</Choose>
									</div>
									<div className="col-sm-3 form-group">
										<label htmlFor="invoiceEndDate">
											{lang.t("Invoice End Date")}
										</label>
										<Choose>
											<When condition={utils.isDesktopSafari || utils.isIE}>
												<MaskedInput
													name="invoiceEndDate"
													id="invoiceEndDate"
													type="text"
													mask={this.dateMask}
													className="form-control"
													placeholder="mm/dd/yyyy"
													value={filters.invoiceEndDate}
													onChange={event =>
														this.handleDateInputChange(
															"invoiceEndDate",
															event,
														)
													}
												/>
											</When>
											<Otherwise>
												<input
													name="invoiceEndDate"
													id="invoiceEndDate"
													type="date"
													className="form-control"
													min={filters.invoiceStartDate}
													value={filters.invoiceEndDate}
													onChange={event =>
														this.handleDateInputChange(
															"invoiceEndDate",
															event,
														)
													}
												/>
											</Otherwise>
										</Choose>
									</div>
								</>
							)}
						</div>
						<div className={`row v-align ${showFilters ? "" : "hidden-xs"}`}>
							<div className="col-sm-6">
								<If condition={user?.Features?.includes("PrePay")}>
									<Switch
										label={lang.t("Only Prepaid")}
										onClick={() => this.handleSwitchChange("prePay")}
										on={filters.prePay === true}
									/>
								</If>
								<If condition={user?.Organization.Id === 9157}>
									<Switch
										label={lang.t("InstantPay")}
										onClick={() => this.handleSwitchChange("sameDayPaid")}
										on={filters.sameDayPaid === true}
										className="toggle-switch"
									/>
								</If>
								<If condition={user.Organization.VehicleInvoicingEnabled}>
									<Switch
										label={lang.t("Vehicle Invoicing Required")}
										onClick={() =>
											this.handleSwitchChange("vehicleInvoicingRequired")
										}
										on={filters.vehicleInvoicingRequired === true}
										className="toggle-switch"
									/>
								</If>
							</div>
							<If
								condition={
									activeType === "payment" &&
									invoiceList.length > 0 &&
									((user.isSuperAdmin() && user.IsStaffAdmin) ||
										user.isAgencyAdmin())
								}
							>
								<div className="col-sm-9 text-right hidden-xs">
									<button
										type="button"
										className="btn btn-primary"
										title="Pay all invoices"
										onClick={() => this.paySelectedInvoices(true)}
									>
										{lang.t("Pay All")}
									</button>
								</div>
							</If>
						</div>
					</div>
					{/* Filters */}

					{/* List Header */}
					<div className="row payment-list-headers hidden-xs">
						<div
							className={
								((user.isAgencyAdmin() || user.isSuperAdmin()) &&
									(activeType === "review" || activeType === "payment")) ||
								(((user.isLEA() &&
									(user.IsStaffAdmin || user.IsInternalCoordinator)) ||
									user.isCoordinator()) &&
									user.Organization.IsOfficerInvoiceApprovalRequired &&
									activeType === "review")
									? "checkbox col-sm-1"
									: "hidden"
							}
						>
							<label htmlFor="selectAll">
								<input
									type="checkbox"
									name="selectAll"
									id="selectAll"
									checked={selectAll}
									onChange={() => this.selectAllInvoices()}
									title={lang.t("Select All")}
									aria-label="Select All Invoices"
								/>
							</label>
						</div>
						<If condition={activeType === "payment"}>
							<strong className="col-sm-1 col-md-2">{lang.t("Sent")}</strong>
						</If>
						<If condition={activeType !== "dispute"}>
							<strong
								className={`${activeType !== "payment" ? `${user.isCoordinator() ? "col-sm-2" : "col-sm-2 col-md-3"}` : "col-sm-2"}`}
							>
								{lang.t("Client")}
							</strong>
						</If>
						<Choose>
							<When condition={activeType === "dispute"}>
								<strong className="col-sm-3">{lang.t("Disputed By")}</strong>
							</When>
							<Otherwise>
								<strong
									className={`${(user.isAgencyAdmin() || user.isCoordinator()) && activeType === "payment" ? "col-sm-2" : "col-sm-3"}`}
								>
									{lang.t("Officer")}
								</strong>
							</Otherwise>
						</Choose>
						<strong
							className={`${
								(activeType === "submission" || activeType === "dispute") &&
								!user.isCoordinator()
									? "col-sm-3"
									: "col-sm-2"
							}`}
						>
							{lang.t("Job Date")}
						</strong>
						<If condition={activeType === "dispute"}>
							<strong className="col-sm-3">{lang.t("Reason")}</strong>
						</If>
						<strong className={`text-right ${amountColumn()}`}>{amountTitle()}</strong>
						<If condition={user.isCoordinator()}>
							<strong
								className={`col-sm-2 ${activeType !== "review" ? "text-right" : ""}`}
							>
								{lang.t("Your Fees")}
							</strong>
						</If>
					</div>
					{/* List Header */}

					{/* List Body */}
					<div className="payment-list-body">
						<For
							each="invoice"
							of={invoiceList}
							index="index"
						>
							<Link
								key={`invoice-item_${invoice?.Id}`}
								to={`/payments/${invoice.Id}`}
							>
								<div className="row v-align-sm">
									<div
										className={
											((user.isAgencyAdmin() || user.isSuperAdmin()) &&
												(activeType === "review" ||
													activeType === "payment")) ||
											(((user.isLEA() &&
												(user.IsStaffAdmin ||
													user.IsInternalCoordinator)) ||
												user.isCoordinator()) &&
												user.Organization
													.IsOfficerInvoiceApprovalRequired &&
												activeType === "review")
												? "checkbox col-sm-1"
												: "hidden"
										}
									>
										<label htmlFor={`checkbox_${invoice?.Id}`}>
											<input
												type="checkbox"
												id={`checkbox_${invoice.Id}`}
												name="selectInvoice"
												checked={selectedInvoices.some(
													({ Id }) => Id === invoice.Id,
												)}
												onChange={() =>
													this.updateSelectedInvoices(invoice.Id)
												}
												onClick={e => e.stopPropagation()}
												aria-label="Select Invoice"
											/>
										</label>
									</div>
									<If condition={activeType === "payment"}>
										<div
											className="col-sm-1 col-md-2 truncate text-right"
											title={utils.formatDate(
												`${invoice?.SentDateTimeUTC}Z`,
												"en-US",
												user.TimeZoneId,
												undefined,
											)}
										>
											{utils.formatDate(
												`${invoice?.SentDateTimeUTC}Z`,
												"en-US",
												user.TimeZoneId,
												undefined,
											)}
										</div>
									</If>
									<If condition={activeType !== "dispute"}>
										<div
											className={`${activeType !== "payment" ? `${user.isCoordinator() ? "col-sm-2" : "col-sm-2 col-md-3"}` : "col-sm-2"}`}
										>
											<strong>{invoice?.ClientName}</strong>
											<div>{invoice?.AgencyName}</div>
											<div>
												{invoice?.JobTitle}
												&nbsp; (
												<button
													type="button"
													className="btn btn-link jobs-button"
													onClick={e => {
														e.preventDefault();
														this.navigateToJob(invoice.JobEventId);
													}}
												>
													{`#${invoice?.JobEventId}`}
												</button>
												)
												<br />
												{`Invoice #${invoice?.Id}`}
											</div>
											<br className="visible-xs" />
										</div>
									</If>
									<Choose>
										<When condition={activeType === "dispute"}>
											<div className="col-sm-3">
												<strong className="visible-xs">
													{lang.t("Disputed By")}
												</strong>
												<div>
													{invoice?.DisputeReason?.DisputedByUserFullName}
												</div>
												<div>{invoice?.ClientName}</div>
												<div>
													{invoice?.JobTitle}
													&nbsp; (
													<button
														type="button"
														className="btn btn-link jobs-button"
														onClick={e => {
															e.preventDefault();
															this.navigateToJob(invoice.JobEventId);
														}}
													>
														{`#${invoice?.JobEventId}`}
													</button>
													)
													<br />
													{`Invoice #${invoice?.Id}`}
												</div>
												<br className="visible-xs" />
											</div>
										</When>
										<Otherwise>
											<div
												className={`${
													(user.isAgencyAdmin() ||
														user.isCoordinator()) &&
													activeType === "payment"
														? "col-sm-2"
														: "col-sm-3"
												}`}
											>
												<Image
													src={invoice.ContactPhotoUrl || ""}
													className="img-circle img-responsive"
													fallbackSrc="avatar"
													alt={`${invoice.OfficerName}'s profile picture`}
												/>
												<span className="officer-name truncate">
													<div title={invoice?.OfficerName}>
														{invoice?.OfficerName}
													</div>
													<div title={invoice?.OfficerRank}>
														<em>{invoice?.OfficerRank}</em>
													</div>
												</span>
											</div>
										</Otherwise>
									</Choose>
									<div
										className={`${
											(activeType === "submission" ||
												activeType === "dispute") &&
											!user.isCoordinator()
												? "col-sm-3"
												: "col-sm-2"
										}`}
									>
										<br className="visible-xs" />
										<div>
											{utils.formatDate(
												`${invoice?.JobStartDateTime}Z`,
												"en-US",
												user.TimeZoneId,
												"w-long",
											)}
										</div>
										<div>
											{utils.formatTime(
												new Date(`${invoice?.JobStartDateTime}Z`),
												user.UserPreferences !== "useMilitaryTime",
												user.TimeZoneId,
											)}
											&nbsp;-&nbsp;
											{utils.formatTime(
												new Date(`${invoice?.JobEndDateTime}Z`),
												user.UserPreferences !== "useMilitaryTime",
												user.TimeZoneId,
											)}
										</div>
										<br className="visible-xs" />
									</div>
									<If condition={activeType === "dispute"}>
										<div className="col-sm-3">
											<em>{invoice?.DisputeReason?.Note}</em>
										</div>
									</If>
									<div className={`payment-amount col-xs-6 ${amountColumn()}`}>
										<strong className="visible-xs-inline">{`${amountTitle()}: `}</strong>
										<span>
											{utils.currencyFormatter(invoice?.TotalInvoice)}
										</span>
										<If condition={invoice?.InvoiceEstimatePrePayment}>
											<br />
											<span className="label label-success">
												{lang.t("Prepaid")}
											</span>
										</If>
										<If condition={invoice?.VehicleInvoicingRequired}>
											<br />
											<span className="label label-warning">
												{lang.t("Vehicle Fees")}
											</span>
										</If>
									</div>
									<If condition={user.isCoordinator()}>
										<div
											className={`text-right ${activeType === "payment" ? "col-sm-2" : "col-sm-1"}`}
										>
											<strong className="visible-xs-inline">{`${lang.t("Your Fees")}: `}</strong>
											<span>
												{utils.currencyFormatter(invoice?.OrganizationFee)}
											</span>
										</div>
									</If>
									<Choose>
										<When
											condition={
												(activeType === "review" ||
													activeType === "paid") &&
												(user.isAgencyAdmin() ||
													user.isSuperAdmin() ||
													user.isLEA() ||
													user.isCoordinator())
											}
										>
											<div
												id={`action-menu_${invoice?.Id}`}
												className={classNames(
													"btn-group col-xs-6 col-sm-1",
													{
														open:
															expandDropdownId !== null &&
															expandDropdownId === invoice?.Id,
													},
												)}
											>
												<button
													type="button"
													name="actionsDropdown"
													className="btn btn-primary dropdown-toggle"
													onClick={e => {
														e.preventDefault();
														this.toggleActionDropdown(invoice?.Id);
													}}
													aria-haspopup="true"
													aria-expanded="false"
												>
													<i
														className={`rkf rkf-spinner rkf-spin rkf-fw${downloadingInvoice === invoice?.Id ? "" : " hidden"}`}
													/>
													{lang.t("Actions")}
													&nbsp;
													<span className="caret" />
												</button>
												<ul className="dropdown-menu">
													<If
														condition={
															activeType === "review" &&
															((user.isAgencyAdmin() &&
																user.IsStaffAdmin) ||
																user.isSuperAdmin())
														}
													>
														<li>
															<button
																type="button"
																id={`approve-invoice_${invoice?.Id}`}
																name="approveInvoice"
																className="btn btn-block text-left"
																onClick={e => {
																	e.preventDefault();
																	this.approveIndividualInvoice(
																		invoice.Id,
																		4,
																	);
																}}
															>
																<i className="glyphicon glyphicon-ok" />
																{lang.t("Approve")}
															</button>
														</li>
														<li>
															<button
																type="button"
																id={`dispute-invoice_${invoice?.Id}`}
																name="disputeInvoice"
																className="btn btn-block text-left"
																onClick={e => {
																	e.preventDefault();
																	this.setState(
																		{
																			disputeInvoiceId:
																				invoice.Id,
																		},
																		() =>
																			this._disputeInvoiceModal.current.open(
																				invoice.Id,
																			),
																	);
																}}
															>
																<i className="glyphicon glyphicon-remove" />
																{lang.t("Dispute")}
															</button>
														</li>
													</If>
													<If
														condition={
															activeType === "paid" &&
															(user.isSuperAdmin() ||
																user.IsStaffAdmin ||
																(user.isLEA() &&
																	user.IsInternalCoordinator))
														}
													>
														<li>
															<button
																type="button"
																id={`edit-invoice_${invoice?.Id}`}
																name="editInvoice"
																className="btn btn-block text-left"
																onClick={e => {
																	e.preventDefault();
																	this.navToShowReceipt(
																		invoice?.Id,
																	);
																}}
															>
																{lang.t("Show Receipt")}
															</button>
														</li>
													</If>
													<If
														condition={
															activeType === "paid" &&
															(user.isSuperAdmin() ||
																user.IsStaffAdmin ||
																(user.isLEA() &&
																	user.IsInternalCoordinator))
														}
													>
														<li>
															<button
																type="button"
																id={`edit-invoice_${invoice?.Id}`}
																name="editInvoice"
																className="btn btn-block text-left"
																onClick={e => {
																	e.preventDefault();
																	this.downloadInvoicePDF(
																		invoice?.Id,
																	);
																}}
															>
																{lang.t("Download")}
																&nbsp;
																{lang.t("Invoice")}
															</button>
														</li>
													</If>
													<If
														condition={
															activeType === "review" &&
															(user.isSuperAdmin() ||
																user.IsStaffAdmin ||
																(user.isLEA() &&
																	user.IsInternalCoordinator))
														}
													>
														<li>
															<button
																type="button"
																id={`edit-invoice_${invoice?.Id}`}
																name="editInvoice"
																className="btn btn-block text-left"
																onClick={e => {
																	e.preventDefault();
																	this.setState(
																		{
																			editInvoiceId:
																				invoice.Id,
																		},
																		() =>
																			this._editInvoiceModal.current.open(),
																	);
																}}
															>
																<i className="glyphicon glyphicon-pencil" />
																{lang.t("Edit")}
															</button>
														</li>
													</If>
													<If
														condition={
															activeType === "review" &&
															(user.isLEA() ||
																user.isCoordinator()) &&
															user.Organization
																.IsOfficerInvoiceApprovalRequired
														}
													>
														<li>
															<button
																type="button"
																id={`send-invoice_${invoice?.Id}`}
																name="sendInvoice"
																className="btn btn-block text-left"
																onClick={e => {
																	e.preventDefault();
																	this.handleSendInvoice(invoice);
																}}
															>
																<i className="glyphicon glyphicon-send" />
																{lang.t("Send")}
															</button>
														</li>
													</If>
												</ul>
											</div>
										</When>
										<When
											condition={
												activeType === "payment" &&
												user.isAgencyAdmin() &&
												user.IsStaffAdmin
											}
										>
											<div className="col-xs-6 col-sm-1">
												<button
													type="button"
													name="payInvoice"
													className="btn btn-primary"
													onClick={e => {
														e.preventDefault();
														this.payIndividualInvoice(invoice.Id);
													}}
												>
													{lang.t("Pay Now")}
												</button>
											</div>
										</When>
									</Choose>
								</div>
							</Link>
						</For>
					</div>
					<If condition={hasMore}>
						<ScrollDetect
							className="text-center"
							onVisible={() => {
								this.getInvoices();
								this.getInvoiceCounts();
							}}
						>
							<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
						</ScrollDetect>
					</If>
					{/* List Body */}
					<If condition={activeType === "paid"}>
						<div className="row">
							<div className="col-sm-12 text-center">
								<Link to="/reports">
									{lang.t("See older paid invoices in reports")}
								</Link>
							</div>
						</div>
					</If>

					{/* Bulk Invoice Actions */}
					<div
						className={`bulk-actions ${selectedInvoices.length > 0 ? "show-actions" : ""}`}
					>
						<div className="row">
							<div className="col-sm-offset-8 col-sm-4 col-md-offset-9 col-md-3 text-right">
								<Choose>
									<When
										condition={
											activeType === "review" &&
											selectedInvoices.length !== 0 &&
											((user.isAgencyAdmin() && user.IsStaffAdmin) ||
												user.isSuperAdmin())
										}
									>
										<button
											type="button"
											className="btn btn-default"
											onClick={() => this.approveSelectedInvoice(4)}
										>
											{lang.t("Approve Selected")}
										</button>
									</When>
									<When
										condition={
											activeType === "payment" &&
											selectedInvoices.length !== 0 &&
											(user.isSuperAdmin() ||
												(user.isAgencyAdmin() && user.IsStaffAdmin))
										}
									>
										<button
											type="button"
											className="btn btn-default"
											onClick={() => this.paySelectedInvoices(false)}
										>
											{lang.t("Pay Selected")}
										</button>
									</When>
									<When
										condition={
											activeType === "review" &&
											((user.isLEA() &&
												(user.IsStaffAdmin ||
													user.IsInternalCoordinator)) ||
												user.isCoordinator()) &&
											user.Organization.IsOfficerInvoiceApprovalRequired &&
											selectedInvoices.length !== 0
										}
									>
										<button
											type="button"
											className="btn btn-default"
											onClick={this.sendSelectedInvoices}
										>
											{lang.t("Send Selected")}
										</button>
									</When>
								</Choose>
							</div>
						</div>
					</div>
					{/* Bulk Invoice Actions */}
				</div>
				<SearchOfficerModal
					show={showSearchOfficerModal}
					user={user}
					closeModal={() => this.setState({ showSearchOfficerModal: false })}
					callback={this.handleOfficerChange}
				/>
				<DisputeInvoiceModal
					ref={this._disputeInvoiceModal}
					onSubmit={() => this.disputeInvoice()}
				/>
				<EditInvoiceModal
					ref={this._editInvoiceModal}
					invoiceId={editInvoiceId}
					user={user}
					onSave={() => this.updateUrl()}
				/>
				<SendToContactModal
					show={showSendInvoiceModal}
					onHide={this.toggleSendInvoiceModal}
					clientId={sendModalClientId}
					onSubmit={(contactId, additionalContacts) =>
						this.sendInvoiceFromModal(sendModalInvoiceId, contactId, additionalContacts)
					}
					isOwnAgency={sendModalAgencyId === user.Organization.Id}
					user={user}
				/>
			</Fragment>
		);
	}
}

PaymentList.propTypes = {
	user: PropTypes.object,
	router: PropTypes.object,
};

PaymentList.defaultProps = {
	user: {},
	router: {},
};

export default PaymentList;
